function ImageLightbox(props){
    return(
    <div id="lightbox_wrapper" onClick={() => props.setImageLightbox(false)}>
        <div id="lightbox_image_wrapper">
            <img id="lightbox_image" src={props.src} />
        </div>
    </div>

    );
}
export default ImageLightbox;